import { render, staticRenderFns } from "./etapa_6.vue?vue&type=template&id=8b6e1d48&scoped=true&"
import script from "./etapa_6.vue?vue&type=script&lang=js&"
export * from "./etapa_6.vue?vue&type=script&lang=js&"
import style0 from "./etapa_6.vue?vue&type=style&index=0&id=8b6e1d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e1d48",
  null
  
)

export default component.exports